export const getRackScan = (state) => state.racks?.singleRack;
